import React, { useEffect, useState } from 'react';
import { default as useMediaQuery } from "@pb/utils/reactHooks/useMediaQuery";
import { Breakpoints } from "@pb/utils/constants/breakpoints";
import { imageTypes } from "@pb/utils/image/getImageUrl";
import { default as isExternalPath } from "@pb/utils/url/isExternalPath";
import cn from 'classnames';
import IntersectionVisible from "../../helpers/IntersectionVisible";
import { CTALink } from "../CTA";
import { ArrowRightIcon } from "../Icon";
import Image from "../Image";
import EditorialParagraph from "../Typography/editorial/EditorialParagraph";
import HeadingLarge from "../Typography/titles/HeadingLarge";
import { ImageFormatProps, teaserCountImageSize } from './constants';
import styles from './EditorialTeaser.module.scss';
import { trackingOnClick, trackingOnView } from './helpers/tracking';
const EditorialTeaser = (props) => {
    const { className, teasers, isTextAtBottom, marginSize } = props;
    const isStacked = useMediaQuery(Breakpoints.MEDIUM);
    const teaserCount = teasers.length;
    const [isTeaserTracking, setIsTeaserTracking] = useState(false);
    const handleScroll = () => {
        if (!isTeaserTracking)
            setIsTeaserTracking(true);
        window.removeEventListener('scroll', handleScroll);
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    }, []);
    if (teaserCount < 1 || teaserCount > 3) {
        return null;
    }
    const getImageSize = (teaser) => teaser.format || (isStacked ? 'small' : teaserCountImageSize[teaserCount]);
    const getImageFormatProp = (teaser) => ImageFormatProps[getImageSize(teaser)];
    const getImageUrl = (teaser) => isStacked ? teaser.imageUrlSmall : teaser[getImageFormatProp(teaser)];
    const handleShow = (isViewTrackingEnabled, trackingPromotionCreative, trackingActivityCode, trackingActivityType) => {
        if (isViewTrackingEnabled && isTeaserTracking) {
            setIsTeaserTracking(false);
            trackingOnView(trackingPromotionCreative, trackingActivityCode, trackingActivityType);
        }
    };
    const handleClick = (onTeaserClick, trackingPromotionCreative, trackingActivityCode, trackingActivityType) => {
        trackingOnClick(trackingPromotionCreative, trackingActivityCode, trackingActivityType);
        if (onTeaserClick) {
            onTeaserClick();
        }
    };
    return (React.createElement("section", { className: cn(styles.teaserContainer, className, marginSize ? styles[`${marginSize}Margin`] : '') }, teasers.map((teaser) => {
        var _a;
        return (React.createElement(IntersectionVisible, { onShow: () => handleShow(teaser === null || teaser === void 0 ? void 0 : teaser.isViewTrackingEnabled, teaser === null || teaser === void 0 ? void 0 : teaser.trackingPromotionCreative, teaser === null || teaser === void 0 ? void 0 : teaser.trackingActivityCode, teaser === null || teaser === void 0 ? void 0 : teaser.trackingActivityType), active: isTeaserTracking, className: styles.teaser },
            React.createElement(CTALink, Object.assign({ className: styles.teaser, href: teaser.linkUrl }, (isExternalPath(teaser.linkUrl) ? { Tag: 'a', target: teaser.target } : {}), { onClick: () => {
                    handleClick(teaser === null || teaser === void 0 ? void 0 : teaser.onTeaserClick, teaser === null || teaser === void 0 ? void 0 : teaser.trackingPromotionCreative, teaser === null || teaser === void 0 ? void 0 : teaser.trackingActivityCode, teaser === null || teaser === void 0 ? void 0 : teaser.trackingActivityType);
                }, key: teaser.headline }),
                React.createElement(Image, { url: getImageUrl(teaser), imageType: imageTypes.TEASER_IMAGE, altText: teaser.imageAltText, className: cn(styles.image, styles[getImageSize(teaser)]) }),
                React.createElement("div", { className: cn(styles.textPlateContainer, isTextAtBottom && styles.textWrapNormal) },
                    React.createElement("div", { className: styles.textPlate },
                        teaser.headline && (React.createElement(HeadingLarge, { className: cn(styles.headline, (_a = teaser.classes) === null || _a === void 0 ? void 0 : _a.headline) }, teaser.headline)),
                        teaser.preamble && (React.createElement(EditorialParagraph, { content: teaser.preamble, lineClamp: 2, className: styles.teaserParagraph })),
                        React.createElement(ArrowRightIcon, { size: isStacked ? 'small' : 'normal', className: styles.icon }))))));
    })));
};
export default EditorialTeaser;
//# sourceMappingURL=EditorialTeaser.js.map